import styles from '../../styles/admin/List.module.scss'

const ClassListHeader = () => {
  const headers = [
    'Level',
    'Main Chapter',
    'Sub Chapter',
    'Unit',
    'Detail Unit',
    'No',
    'Content Type',
    'Depth',
    'Modify',
    'Delete',
  ]

  return (
    <div className={styles.listHeader}>
      {headers.map((header, index) => (
        <div key={index} className={styles.cell} style={{ width: '10px' }}>
          {header}
        </div>
      ))}
    </div>
  )
}

export default ClassListHeader
